import axios from 'axios';
import { QFilters } from '../../redux/state/dashboardState';
export const initialFilter = {
    account_id: "",
    contact_id: "",
    source: "cp",
    cp_user_id: '',
    accountName: '',
};
export const fetchQuotesReqApproval = (limit: number = 50, offset: number = 0, order: string, orient: string = "asc", filters: QFilters = initialFilter) => {
    let url = `/api/v1/orders?term[orderType]=Quote&source=cp&limit=${limit}&offset=${offset}&order=${order}&orient=${orient}`;
    for (let key in filters) {
        if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'cp_user_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'source')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'account_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'orderIdentity')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'orderNo')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters[key].length && filters[key] && !Array.isArray(filters[key]) && (key !== 'account_id' && key !== 'orderIdentity' && key !== 'orderNo')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters[key].length && Array.isArray(filters[key])) {
            filters[key].forEach(el => {
                url += `&term[${key}][]=${el}`
            });
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        }
    }
    return axios.get(url);
};
export const fetchCatalogues = (session) => {
    let url = `/api/v1/products?term[productType]=1,2&source=cp&isDeleted=0&limit=1&offset=0&order=productName&orient=asc`;
    if (session.user) {
        if (session.user.portalPermissions && !session.user.portalPermissions.Order[0].allowedOtherContacts) {
            url += `&contact_id=${session.user.contactId}`;
        }
        url += `&account_id=${session.user.accountId}`;
        url += `&cp_user_id=${session.user.contactId}`;
    }
    return axios.get(url);
};
export const fetchPastDueOrdersCount = (session) => {
    let url = `/api/v1/orders?source=cp&total_count_only=1&term[orderType][]=Order&term[orderType][]=CreditMemo&term[orderType][]=StoreOrder`;
    url += `&term[orderStatus][]=Billed`;
    url += `&term[paymentStatus][]=Partial`;
    url += `&term[paymentStatus][]=Unpaid`;
    if (session.user) {
        if (session.user.portalPermissions && !session.user.portalPermissions.Order[0].allowedOtherContacts) {
            url += `&contact_id=${session.user.contactId}`;
        }
        url += `&account_id=${session.user.accountId}`;
        url += `&cp_user_id=${session.user.contactId}`;
    }
    return axios.get(url);
};
export const fetchBilledOrdersCount = (session) => {
    let url = `/api/v1/orders?source=cp&total_count_only=1&term[orderType][]=Order&term[orderType][]=CreditMemo&term[orderType][]=StoreOrder`;
    url += `&term[paymentStatus][]=Partial`;
    url += `&term[paymentStatus][]=Unpaid`;
    url += `&term[orderStatus][]=Booked`;
    url += `&term[orderStatus][]=Billed`;
    url += `&term[orderStatus][]=Pending`;
    if (session.user) {
        if (session.user.portalPermissions && !session.user.portalPermissions.Order[0].allowedOtherContacts) {
            url += `&contact_id=${session.user.contactId}`;
        }
        url += `&account_id=${session.user.accountId}`;
        url += `&cp_user_id=${session.user.contactId}`;
    }
    return axios.get(url);
};

export const accountDetails = (session) => {
    let url = `/content/get-contact-cards`;
    return axios.post(url, {
        id: session.user.contactId ?? ""
    });
};

export const fetchOrdersReqApproval = (limit: number = 50, offset: number = 0, order: string, orient: string = "asc", filters: QFilters = initialFilter) => {
    let url = `/api/v1/orders?term[orderType]=Order&source=cp&limit=${limit}&offset=${offset}&order=${order}&orient=${orient}`;
    for (let key in filters) {
        if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'cp_user_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'source')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'account_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'orderIdentity')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'orderNo')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters[key].length && filters[key] && !Array.isArray(filters[key]) && (key !== 'account_id' && key !== 'orderIdentity' && key !== 'orderNo')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters[key].length && Array.isArray(filters[key])) {
            filters[key].forEach(el => {
                url += `&term[${key}][]=${el}`
            });
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        }
    }
    return axios.get(url);
};
